import { ToasterService } from 'angular2-toaster';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent implements OnInit {
  message: any;
  codeSent: boolean;
  resetEmail: string;
  verificationCode: string;
  newPassword: string;
  error: boolean;

  constructor(public auth: AuthService, public router: Router, private toasterService: ToasterService) {}

  ngOnInit() {}

  cleanState() {
    this.message = '';
    this.error = false;
  }
  onForget() {
    localStorage.clear(); // user loses session once clicks forgot password
    this.cleanState();
    this.auth
      .forgotPassword(this.resetEmail)
      .then(success => {
        this.message = 'Sent verification code to reset password, please check email';
        this.codeSent = true;
      })
      .catch(err => {
        console.error(err);
        this.message = `Error sending email: ${err.message}`;
        this.error = true;
      });
  }

  onReset() {
    this.cleanState();
    this.auth
      .confirmPassword(this.resetEmail, this.verificationCode, this.newPassword)
      .then(success => {
        this.toasterService.pop('success', 'Confirmed new password');
        this.router.navigate(['/signin']);
      })
      .catch(error => {
        this.codeSent = false;
        console.error(error);
        const message = error.message || `check user information or contact admin.`;
        this.message = `Try again, error: ${message}`;
        this.error = true;
        this.verificationCode = '';
        this.newPassword = '';
      });
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/auth/forgot/forgot.component.ts